import { CDN_URL } from '@constants/globals'

const contentfulCDNUrlRegex = new RegExp('//(images|videos).ctfassets.net', 'giu')

export const updateAssetCDNUrl = (url?: string) =>
  url?.replaceAll(contentfulCDNUrlRegex, CDN_URL) ?? ''
